// VLAXA-6871: Keep this code as Stripe might be reused in the future
// We still use this hook so the patient gets redirected to the survey only

import { useCallback } from 'react';
// import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
// import { infoModal } from 'vl-common/src/components/Modals';
// import useAuth from '@vl-core/useAuth';

export type SurveyPreviousPage = 'todos' | 'documents';

export const surveyPreviousPages: SurveyPreviousPage[] = ['todos', 'documents'];

export const isSurveyPreviousPage = (value: unknown): value is SurveyPreviousPage =>
  typeof value === 'string' && (surveyPreviousPages as string[]).includes(value);

export default function useNeedCardDetails() {
  // const { t } = useTranslation('common');
  // const { user } = useAuth();
  const { push /*, pathname */ } = useRouter();
  // const isAssessmentPage = pathname === '/patients/assessments';

  const getSurveyLink = useCallback((surveyId: number) => `/patients/assessments?surveyjs_id=${surveyId}`, []);
  // const getNeedsCardDetails = useCallback(
  //   (cardDetailsMandatory: boolean) => cardDetailsMandatory && !!user?.needs_recent_card_details,
  //   [user?.needs_recent_card_details]
  // );

  // const openCardDetailsModal = useCallback(
  //   (surveyId: number) => {
  //     infoModal({
  //       title: 'Provide card details',
  //       content: t('It is possible that you may have an excess on your policy or some charges may not be settled by your insurer. Since you have a new case, it is HBSUK’s policy to request that you provide or re-confirm your payment card details.'),
  //       okText: 'Set up card',
  //       closable: true,
  //       onOk: () => {
  //         window.sessionStorage.setItem('cardSetup', 'true');
  //         window.sessionStorage.setItem('cardSetupAction', 'Answer survey');
  //         window.sessionStorage.setItem(
  //           'cardSetupRedirectLink',
  //           Buffer.from(getSurveyLink(surveyId)).toString('base64')
  //         );
  //         push('/patients/profile');
  //       },
  //       onCancel: () => {
  //         if (isAssessmentPage) push('/patients/');
  //       }
  //     });
  //   },
  //   [getSurveyLink, isAssessmentPage, push]
  // );

  // const showNeedCardDetailsModal = useCallback(
  //   (surveyId: number, cardDetailsMandatory: boolean) => {
  //     const needsCardDetails = getNeedsCardDetails(cardDetailsMandatory);

  //     if (needsCardDetails) {
  //       openCardDetailsModal(surveyId);
  //     }
  //   },
  //   [getNeedsCardDetails, openCardDetailsModal]
  //);

  const showNeedCardDetailsOrRedirectToSurvey = useCallback(
    (surveyId: number, previous?: SurveyPreviousPage /*,cardDetailsMandatory: boolean*/) => {
      // const needsCardDetails = getNeedsCardDetails(cardDetailsMandatory);

      // if (needsCardDetails) {
      //   openCardDetailsModal(surveyId);
      // } else {
      const link = previous ? `${getSurveyLink(surveyId)}&previous=${previous}` : getSurveyLink(surveyId);
      push(link);
      // }
    },
    [/*getNeedsCardDetails, */ getSurveyLink, /*openCardDetailsModal, */ push]
  );

  return { /*showNeedCardDetailsModal,*/ showNeedCardDetailsOrRedirectToSurvey };
}
